export default function TermsCheckbox( { id, label, checked, onChange } ) {
    return (
		<div className="wc-block-components-checkbox">
			<label htmlFor={ id }>
				<input
					id={ id }
					className="wc-block-components-checkbox__input"
					type="checkbox"
					aria-invalid="false"
					checked={ checked }
					onChange={ onChange }
				/>
				<svg
					className="wc-block-components-checkbox__mark"
					aria-hidden="true"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 20"
				>
					<path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path>
				</svg>
				<span class="wc-block-components-checkbox__label">
					{ label }
				</span>
			</label>
		</div>
	);
}